import { useState, useEffect, useRef } from 'react'
import { Typography, Button, IconButton, Box, Stack,
         InputLabel, TextField, Select, Table, TableContainer,
         TableHead, TableBody, TableRow, TableCell, Pagination,
         Checkbox, FormControlLabel
       } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useConfirm } from '@/components/ConfirmProvider'
import { admSend } from 'api/users';

  const headerCellStyle = {
    // width: '80px',
    bgcolor: 'grey.50'
    , borderTop: '1px solid'
    , borderColor: 'divider'
    // , cursor: 'pointer'
    , color: 'text.primary'
    , textAlign: 'center'
    , textDecoration: 'none'
  }

/**
 * 권한관리 
 **/
function AuthMng () {
  const navigate = useNavigate();
  const location = useLocation();
  const { alert } = useConfirm();
  
  const searchYn      = location.state?.searchYn;
  const navParamData  = location.state?.navParamData; // 조회조건
  const searchData    = location.state?.dtlInfo;    // 선택 정보(상세조회조건)
  const remarksRef    = useRef(null); // 변경사유 focus

  /* 변경이력 pagenavigation */
  const [page, setPage]           = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const itemsPerPage = 10;

  // 조회 조건
  const [paramData, setParamData] = useState({
    page : page, 
    authGradeCode : "",
    authGradeName : "",
    authGroupId : "",
    authGroupName : "",
  });

  // 선택 상세정보
  const [dtlData, setDtlData] = useState({
    page : page, 
    authGradeCode : "",
    authGradeName : "",
    authGroupId : "",
    authGroupName : "",
    remarks : "",
    authMenuList : []
  });

  const [aprovMenuList, setAprovMenuList] = useState([]); // 메뉴
  const [userGrpList, setUserGrpList] = useState([]);     // 연관 사용자 그룹
  const [chgLogList, setChgLogList] = useState([]);       // 변경이력


// ====================== 공통 함수 ======================
  // 개별 체크 변경 함수
  const handleCheckboxChange = (menuId, field, value) => {
    setAprovMenuList((prev) =>
      prev.map((menu) =>
        menu.menuId === menuId ? { ...menu, [field]: value } : menu

  )
    );
  };

  /* 유효성 검사 */
  const validation = () => {
    if( !dtlData.authGroupName ) {
      alert('권한명이 입력되지 않았습니다.');
      return false;
    }

    if( !dtlData.remarks ) {
      alert('변경사유가 입력되지 않았습니다.');
      remarksRef.current?.focus();
      return false;
    }

    return true;
  }


// ====================== 사용자 업무 함수 ======================
  // 권한 메뉴 정보 조회
  const searchDtail = async () => {
    try {
      const resData = await admSend('/getAuthMenuList', searchData);
      setAprovMenuList(resData.data?.content);
    } catch (error) {
      console.error('권한정보 불러오기 실패:', error);
    }
  };

  /* 변경이력 조회 */
  const searchChgLog = async () => {
    try {
      const resData = await admSend('/getAuthMngChgLogList', searchData);
      setChgLogList(resData.data?.content);
      setTotalPage(resData.data?.totalElements);
    } catch (error) {
      console.error('권한정보 불러오기 실패:', error);
    }

  }

  // 관련 사용자그룹 목록 조회
  const searchUserGrp = async () => {
    try {
      const resData = await admSend('/getSubUserGrpList', searchData);
      setUserGrpList(resData.data?.content);
    } catch (error) {
      console.error('관련 사용자그룹 조회 실패:', error);
    }
  };

  // 메뉴권한 저장
  const saveAuth = async (data) => {

    if ( validation() ) {
      try {
        const result = await admSend('/saveAuthDtail', data);
        
        if ( result ) {
          const alt = await alert("수정되었습니다.");
          if ( alt ) {
              navigate('/mng/authMng',   { state: { searchYn : searchYn, navParamData : navParamData} });
          }
        }
      } catch (error) {
        console.error('권한정보 수정 실패:', error);
      }
    }
  };


// ====================== CallBack 함수 ======================


// ====================== useEffect ======================
  // 최초 정보 조회
  useEffect(() => {
    if( searchData.authGroupId ) {
      setDtlData({
        ...dtlData,
        authGradeCode : searchData.authGradeCode,
        authGradeName : searchData.authGradeName,
        authGroupId   : searchData.authGroupId,
        authGroupName : searchData.authGroupName,
      });

      searchDtail();
      searchChgLog();
      searchUserGrp();
    }
  }, [searchData]);

  return (
    <div>
      {/* 🔍 검색 조건 UI */}
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mt: 2 }}>
        {/* 기관 */}
        <Typography sx={{ width: 80 }}>기관명</Typography>
        <TextField
          sx={{ width: 580 }}
          id="insttName" 
          name="insttName" 
          label="기관명"
          value={dtlData?.authGradeName}
          disabled={true}
        />
      </Stack>

      <Stack direction="row" alignItems="center" spacing={2} sx={{ mt: 2 }}>
        {/* 권한명 */}
        <InputLabel sx={{ width: 80 }}>권한명</InputLabel>
        <TextField
          id="insttCode" 
          name="insttCode" 
          sx={{ width: 580 }}
          label="권한명"
          value={dtlData?.authGroupName}
          onChange={(e) => {
            setDtlData({
              ...dtlData,
              authGroupName : e.target.value
            })
          }}
        />
      </Stack>

      <TableContainer sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellStyle}>1Depth</TableCell>
              <TableCell sx={headerCellStyle}>2Depth</TableCell>
              <TableCell sx={headerCellStyle}>3Depth</TableCell>
              <TableCell sx={headerCellStyle} colSpan={2}>권한</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {
              aprovMenuList?.length === 0 ? (
                <TableRow>
                  <TableCell align="center" colSpan={4}>등록된 메뉴가 없습니다.</TableCell>
                </TableRow>
              ) : (
                aprovMenuList?.map((menu) => (
                  <TableRow key={menu.authGrpId}>
                    <TableCell align="center">{menu.menuLevel === "1" ? menu.menuName : ""}</TableCell>
                    <TableCell align="center">{menu.menuLevel === "2" ? menu.menuName : ""}</TableCell>
                    <TableCell align="center">{menu.menuLevel === "3" ? menu.menuName : ""}</TableCell>
                    <TableCell padding="checkbox">
                      <FormControlLabel
                        control={<Checkbox
                                    checked={menu.authEditYn === 'Y'}
                                    onChange={(e) => {
                                      const value = e.target.checked ? 'Y' : 'N';
                                      handleCheckboxChange(menu.menuId, "authEditYn", value);
                                    }}
                        />}
                        label={"편집"}
                      />
                    </TableCell>
                    <TableCell padding="checkbox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={menu.authApovYn === 'Y'}
                            onChange={(e) => {
                              const value = e.target.checked ? 'Y' : 'N';
                              handleCheckboxChange(menu.menuId, "authApovYn", value);
                            }}
                          />
                        }
                        label={"승인"}
                      />
                    </TableCell>
                  </TableRow>

                ))
              )
            }
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
        <Button
          sx={{ p: 3, border: '13px', borderRadius: '8px' }}
          variant="contained"
          color="primary"
          onClick={() => {
            navigate('/mng/authMng',   { state: { searchYn : searchYn, navParamData : navParamData} });
          }}
        >취소</Button>
        <Button
          sx={{ p: 3, border: '13px', borderRadius: '8px' }}
          variant="contained"
          color="primary"
          onClick={() => {
            const saveData = {
              ...dtlData,
              authMenuList : aprovMenuList
            };

            saveAuth(saveData);
          }}
        >수정</Button>
      </Box>

      {/* 변경사유 */}
      <TextField
        sx={{ mt: 2, width : '100%' }}
        name="body"
        placeholder="변경사유를 입력해 주세요"
        multiline
        rows={4}
        required
        inputRef={remarksRef}
        value={dtlData.remarks}
        onChange={(e) => {
          setDtlData({
            ...dtlData,
            remarks : e.target.value
          })        
        }}
      />
    
        {/*-- 변경이력 목록 --*/}
      <TableContainer sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider'}}>변경내용</TableCell>
              <TableCell align="center" sx={{width: '120px', bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider'}}>담당자</TableCell>
              <TableCell align="center" sx={{width: '120px', bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider'}}>일자</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {
              chgLogList?.length === 0 ? (
                <TableRow>
                  <TableCell align="center" colSpan={3}>변경 이력이 존재하지 않습니다.</TableCell>
                </TableRow>
              ) : (
                chgLogList?.map((chgLog, index) => (
                  <TableRow key={index}>
                    <TableCell>{chgLog.remarks}</TableCell>
                    <TableCell>{chgLog.registNm}</TableCell>
                    <TableCell>{chgLog.registDttm}</TableCell>
                  </TableRow>
                ))
              )
            }
          </TableBody>
        </Table>
      </TableContainer>
      {
      totalPage != 0 && (
      <Pagination
        count={Math.ceil((totalPage? totalPage : 0) / itemsPerPage)}
        page={page}
        onChange={(e, value) => {
          setParamData({
            ...paramData,
            page : value 
          });
          setPage(value);
        }}
        showFirstButton
        showLastButton
        sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
      />
      )
      }

      <Stack alignItems="left" sx={{ mt: 5, fontSize: 24, fontWeight: 'bold' }}>
        ○ 연관 사용자그룹
      </Stack>

      <TableContainer sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '80px', textAlign: 'center', bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider' }}>번호</TableCell>
              <TableCell sx={{ textAlign: 'center', bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider' }}>그룹명</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {
              userGrpList.length === 0 ? (
                <TableRow>
                  <TableCell align="center" colSpan={2}>연관 된 사용자그룹이 없습니다.</TableCell>
                </TableRow>
              ) : (
                userGrpList.map((grp) => (
                  <TableRow>
                    <TableCell align="center"sx={{ width: '150px' }}>{grp.rowNum}</TableCell>
                    <TableCell align="center">{grp.workGroupName}</TableCell>
                  </TableRow>

                ))
              )
            }
          </TableBody>
        </Table>
      </TableContainer>

    </div>
  )
}

export default AuthMng;